<template>
    <layout class="user-center-wrapper">
        <div class="user-top">
            <img :src="userInfo.avatar" alt="" class="user-head" v-if="userInfo && userInfo.avatar">
            <img src="../assets/img/user.png" alt="" class="user-head" v-else>
            <div class="base-info">
                <div class="nickname">{{userInfo | safeGetter('name')}}</div>
                <div class="card-no">卡号：{{userInfo | safeGetter('cardNo')}}</div>
            </div>
        </div>
        <ul class="menu-list">
            <li class="icon-member" @click="handleMember">
                <div class="label">我的成员</div>
                <span class="value">{{members | joinMembers}}</span>
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </li>
            <li class="icon-use" @click="handleUseHistory">
                <div class="label">使用记录</div>
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </li>
            <li class="icon-recharge" @click="handleRechargeHistory">
                <div class="label">充值记录</div>
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </li>
            <li class="icon-upload" @click="handleReport">
                <div class="label">数据上传</div>
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </li>
            <li class="icon-mobile" @click="handleBindingMobile">
                <div class="label">绑定手机</div>
                <span class="value">{{userInfo | safeGetter('mobile')}}</span>
                <van-icon name="arrow" color="#CECECE" size="18px"/>
            </li>
        </ul>
    </layout>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "UserCenter",
        data() {
          return {
              test: null
          }
        },
        computed: {
            curMemberName() {
                let curMember = this.curMember;
                if (curMember) {
                    return curMember.name;
                } else {
                    return '';
                }
            },
            ...mapState([
                'userInfo',
                'members'
            ])
        },
        filters: {
            joinMembers(value) {
                if (value) {
                    return value.map(item => item.name).join(',');
                } else {
                    return '';
                }
            }
        },
        methods: {
            handleMember() {
                this.$router.push('/member');
            },
            handleUseHistory() {
                this.$router.push('/useHistory');
            },
            handleRechargeHistory() {
                this.$router.push('/rechargeHistory');
            },
            handleBindingMobile() {
                this.$router.push('/bindingMobile');
            },
            handleReport() {
                this.$router.push('/reportHistory');
            }
        }
    }
</script>

<style scoped>

</style>